import './EmptyOverviewStyle.scss';

import PropTypes from 'prop-types';
import React from 'react';
import SearchHeaderContainer from 'src/components/SearchHeader';
import TableCardComponent from 'src/components/TableCard/TableCardComponent';
import { Link, Message, Spacer, Title } from 'src/core/components';

import messages from './messages';

const EmptyOverview = ({
  staticMenuItems,
  menuGroups,
  selectedMenuItem,
  onSelectMenuItem,
  searchFormData,
  setSearchFormData,
  showAdvanceSearch,
  setShowAdvanceSearch,
  radioSelected,
  setRadioSelected,
  filterFormData,
  setFilterFormData,
}) => (
  <>
    <SearchHeaderContainer
      menuGroups={menuGroups}
      selectedMenuItem={selectedMenuItem}
      onSelectMenuItem={onSelectMenuItem}
      searchFormData={searchFormData}
      setSearchFormData={setSearchFormData}
      showAdvanceSearch={showAdvanceSearch}
      setShowAdvanceSearch={setShowAdvanceSearch}
      radioSelected={radioSelected}
      setRadioSelected={setRadioSelected}
      filterFormData={filterFormData}
      setFilterFormData={setFilterFormData}
    />
    <div className="mt-4">
      <TableCardComponent
        {...{
          title: '',
          subtitle: '',
          expanded: true,
          onViewAll: null,
        }}
      >
        <div className="mt-5 table-no-data">
          <Message
            className="mcp-static-links-title justify-content-center"
            message={{
              id: 'noDataFound',
              defaultMessage: 'There is no data to show.',
            }}
          />
        </div>
      </TableCardComponent>
    </div>

    {false && (
      <>
        <Title
          className="mcp-static-links-title"
          size="3"
          message={messages.toolsForProject}
        />
        <Spacer bottom={16} />
        <div className="mcp-static-links">
          <Link href={staticMenuItems[0].productLink} target="_blank">
            {staticMenuItems[0].name}
          </Link>
          <Link href={staticMenuItems[1].productLink} target="_blank">
            {staticMenuItems[1].name}
          </Link>
        </div>
        <Spacer bottom={56} />
        <Title
          className="mcp-static-links-title"
          size="3"
          message={messages.customizedProducts}
        />
        <Spacer bottom={16} />
        <div className="mcp-static-links">
          <Link href={staticMenuItems[0].productLink} target="_blank">
            <Message message={messages.seeYourProducts} />
          </Link>
          <Link href={staticMenuItems[3]?.productLink} target="_blank">
            <Message message={messages.customProductsLines} />
          </Link>
        </div>
      </>
    )}
  </>
);

EmptyOverview.propTypes = {
  staticMenuItems: PropTypes.array,
  selectedMenuItem: PropTypes.object,
  onSelectMenuItem: PropTypes.func,
  menuGroups: PropTypes.array.isRequired,
  searchFormData: PropTypes.object,
  setSearchFormData: PropTypes.func,
  showAdvanceSearch: PropTypes.bool,
  setShowAdvanceSearch: PropTypes.func,
  radioSelected: PropTypes.string,
  setRadioSelected: PropTypes.func,
  filterFormData: PropTypes.object,
  setFilterFormData: PropTypes.func,
};

export default EmptyOverview;
